// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__Hco_J","header":"PatientQuestionnaire_header__2nc9v","info":"PatientQuestionnaire_info__3n-zn"};